import { IDirectSignupState } from '../features/directSignup/directSignupSlice';
import { IDirectSignupRes } from '../components/registration/registration.interface';
import { getMobileOperatingSystem } from './WindowHelper';

export const buildDirectSignup = (state: IDirectSignupState, sandbox: boolean): IDirectSignupRes => {
  return {
    firstName: '',
    lastName: '',
    hatName: state.username,
    email: state.email,
    password: state.password,
    newsletterOptin: state.newsletterOptin,
    termsAgreed: state.termsAgreed,
    sandbox: sandbox,
    //not using the app_id env variable here. Better to rely if the sign up is for sandbox or not
    applicationId: sandbox ? 'hatappstaging' : 'hatapp',
    platform: getMobileOperatingSystem(),
    country: 'UK',
  };
};

export const buildRequestURL = (url: string, params?: { [key: string]: string }) => {
  if (!params) return url;

  const esc = encodeURIComponent;
  const query = Object.keys(params)
    .map((k) => esc(k) + '=' + esc(params[k]))
    .join('&');

  if (!query) return url;

  return url + (url.indexOf('?') !== -1 ? '&' + query : '?' + query);
};

export const isTrackingAllowed = (): boolean => {
  // TODO Check if tracking is allowed.
  return true;
};
